module.exports = __webpack_public_path__ + "b5f0c9785d247755dd2e78c565dcbdbb.png";